export class DbTableIdentification {
    catalogName = "";
    schemaName = "";
    tableName = "";
}
